import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppShell from './AppShell';

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
